export default __webpack_public_path__ + "static/media/finish-porcelain.d233965a.jpg";